export const BASE_URL = process.env.REACT_APP_API_HOST;
export const URI = '';



// WEBPACK FOOTER //
// ./src/config.js